import classnames from 'classnames/bind';
import { Badge } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import {
    AlertWrapper,
    TrackingBadgeTooltipComponent,
    useTrackingBadgeAndTooltip,
} from '../../hooks/useTrackingBadgeAndTooltip';
import styles from './trackingNavigationItemContent.module.scss';

const classNameBuilder = classnames.bind(styles);

export const TrackingNavigationItemContent = ({ caption, icon: IconComponent, className }) => {
    const { showBadgeAndTooltip, badgeType, tooltipContent, pixelStatus } = useTrackingBadgeAndTooltip();

    return (
        <Badge
            badgeContent={<AlertWrapper type={badgeType} />}
            hideBadge={!showBadgeAndTooltip}
            type={Badge.TYPE.ERROR}
            contentClassName={classNameBuilder('prioritized', 'badge-content')}
        >
            <IconComponent className={classNameBuilder(styles['icon'], className)} />
            <FormattedMessage id={caption.id} defaultMessage={caption.default} />
            {showBadgeAndTooltip && (
                <TrackingBadgeTooltipComponent
                    show={showBadgeAndTooltip}
                    badgeType={badgeType}
                    tooltipContent={tooltipContent}
                    pixelStatus={pixelStatus}
                />
            )}
        </Badge>
    );
};
